import React from 'react';
import { RadioButton } from 'react-native-paper';
import { Platform, StyleSheet, View } from 'react-native';
import { useController } from 'react-hook-form';

import { FormGroupRadioButtonProps } from '@nocode/types/formGroup.type';
import { isCanvas } from '@common/utils';

const FormGroupRadioButton = ({
  name,
  options,
  width,
  styleConfig,
}: FormGroupRadioButtonProps) => {
  const canvas = isCanvas() && Platform.OS === 'web';
  const style = createStyles(styleConfig, canvas ? 335 : width);

  const {
    field,
    fieldState: { invalid, isTouched, isDirty },
    formState: { touchedFields, dirtyFields },
  } = useController({
    name,
    defaultValue: '',
  });

  const handlePress = (value: string) => {
    if (canvas) {
      return;
    }

    field.onChange(value);
  };

  return (
    <RadioButton.Group value={field.value} onValueChange={handlePress}>
      {options.map((option) => (
        <View style={style.optionWrapper} key={option.label}>
          <RadioButton.Item
            value={option.value as string}
            status={field.value === option.value ? 'checked' : 'unchecked'}
            label={option.label}
            position="leading"
            style={style.radioButtonItem}
            labelStyle={style.label}
            color={styleConfig?.activeColor}
            uncheckedColor={styleConfig?.inactiveColor}
          />
        </View>
      ))}
    </RadioButton.Group>
  );
};

const createStyles = (
  style: FormGroupRadioButtonProps['styleConfig'],
  width: number
) => {
  return StyleSheet.create({
    optionWrapper: {
      marginBottom: 8,
    },
    radioButtonItem: {
      borderRadius: style?.borderRadius || 0,
      borderColor: style?.borderColor,
      backgroundColor: style?.backgroundColor,
      borderWidth: style?.borderWidth,
      maxWidth: 360,
      paddingVertical: 2,
      width,
    },
    label: {
      color: style?.color,
      textAlign: 'left',
      fontSize: style?.fontSize,
    },
  });
};

export default FormGroupRadioButton;
